import { Box, Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PropagateLoader } from "react-spinners";
import SubmitBtn from '../../components/button/SubmitBtn';
import DatePicker from '../../components/input/DatePicker';
import DynamicInput from '../../components/input/DynamicInput';
import GenderPicker from '../../components/input/GenderPicker';
import SimpleInput from '../../components/input/SimpleInput';
import UploadImage from '../../components/input/UploadImage';
import InputTags from '../../components/InputTags/InputTags';
import PopUp from '../../components/PopUp';
import fb_icon from '../../img/fb_icon.svg';
import ig_icon from '../../img/ig_icon.svg';
import linkedIn_icon from '../../img/linkedIn_icon.svg';
import fb_logo from '../../img/popUpBox/fb_logo.svg';
import ig_logo from '../../img/popUpBox/ig_logo.svg';
import linkedIn_logo from '../../img/popUpBox/linkedIn_logo.svg';
import { getProfile } from '../../services/PersonalService';
import { RootStoreContext } from '../../store';
import style from './Personal.module.css';

function Personal() {
  const { PersonalStore } = useContext(RootStoreContext);

  const [igToggle, setIgToggle] = useState(false);
  const [fbToggle, setFbToggle] = useState(false);
  const [linkedInToggle, setLinkedInToggle] = useState(false);
  const igClicked = () => {
    setIgToggle(!igToggle);
  };
  const fbClicked = () => {
    setFbToggle(!fbToggle);
  };
  const linkedInClicked = () => {
    setLinkedInToggle(!linkedInToggle);
  };
  const {
    profile_picture,
    gender,
    birthday,
    softPower,
    hardPower,
    motivation,
    igLink,
    fbLink,
    linkedInLink,
    updateData,
    username,
    email,
    experience,
  } = PersonalStore;
  const [personalData, setPersonalData] = useState({
    profile_picture: profile_picture,
    gender: gender,
    softPower: softPower,
    hardPower: hardPower,
    motivation: motivation,
    username: username,
    birthday: birthday,
    email: email,
    experience: experience,
    igLink: igLink,
    linkedInLink: linkedInLink,
    fbLink: fbLink,
  });

  useEffect(() => {
    getProfile().then((value) => {
      if (value) {
        updateData('username', value.username);
        updateData('profile_picture', value.profile_picture);
        updateData('gender', value.gender);
        updateData('birthday', value.birthday);
        updateData('email', value.email);
        updateData('experience', value.experience);
        updateData('softPower', value.softPower);
        updateData('hardPower', value.hardPower);
        updateData('motivation', value.motivation);
        updateData('igLink', value.igLink ? value.igLink : '');
        updateData('fbLink', value.fbLink ? value.fbLink : '');
        updateData('linkedInLink', value.linkedInLink ? value.linkedInLink : '');
      }
    });
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);
  if (loading) return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <PropagateLoader loading={loading} />
      </div>
    </div>
  );


  const handleChangeGender = (gender) => {
    setPersonalData({ ...personalData, gender: gender });
    updateData('gender', gender);
  }

  const handleChangeDate = (birthday) => {
    setPersonalData({ ...personalData, birthday: birthday });
    updateData('birthday', birthday);
  }

  return (
    <Grid container>
      <Grid item xs={12} className={style.mid}>
        <img src={profile_picture} alt="profile" className={style.img} />
        <div className={style.imgbtn}>
          <UploadImage />
        </div>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={ig_icon} alt="ig_icon" onClick={igClicked} className={style.sm_logo} />
          {igToggle ? (
            <PopUp
              img={ig_logo}
              toggle={igClicked}
              title="instagram"
              update={(input) => setPersonalData({ ...personalData, igLink: input })}
              value={igLink}
            />
          ) : null}
          <img
            src={linkedIn_icon}
            alt="linkedIn_icon"
            style={{
              marginLeft: '0.75em',
              marginRight: '1em',
            }}
            onClick={linkedInClicked}
            className={style.sm_logo}
          />
          {linkedInToggle ? (
            <PopUp
              img={linkedIn_logo}
              toggle={linkedInClicked}
              title="linkedIn"
              update={(input) => setPersonalData({ ...personalData, linkedInLink: input })}
              value={linkedInLink}
            />
          ) : null}
          <img src={fb_icon} alt="fb_icon" onClick={fbClicked} className={style.sm_logo} />
          {fbToggle ? (
            <PopUp
              img={fb_logo}
              toggle={fbClicked}
              title="facebook"
              update={(input) => setPersonalData({ ...personalData, fbLink: input })}
              value={fbLink}
            />
          ) : null}
        </Box>
        <Link to="/Profile_show" className={style.submit}>
          <SubmitBtn label="保存" userData={personalData} />
        </Link>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12} lg={4}>
            <div className={style.gap} />
            <TextField
              id="outlined-basic"
              label={'請輸入您的名字'}
              value={username}
              onChange={(e) => {
                setPersonalData({ ...personalData, username: e.target.value });
                updateData('username', e.target.value);
                console.log(personalData);
              }}
              variant="outlined"
              style={{ width: '400px', margin: '3% 13% 0 0' }}
              InputProps={{
                style: {
                  fontSize: 14,
                  color: '#595959',
                },
              }}
            />
            <div className={style.all}>
              <div className={style.gender}>
                <GenderPicker handleChangeGender={handleChangeGender} />
              </div>
              <div className={style.date}>
                <DatePicker handleChangeDate={handleChangeDate}/>
              </div>
            </div>
            <TextField
              id="outlined-basic"
              label={'請輸入您的信箱'}
              value={email}
              onChange={(e) => {
                setPersonalData({ ...personalData, email: e.target.value });
                updateData('email', e.target.value);
                console.log(personalData);
              }}
              variant="outlined"
              style={{ width: '400px', margin: '3% 13% 0 0' }}
              InputProps={{
                style: {
                  fontSize: 14,
                  color: '#595959',
                },
              }}
            />
            <TextField
              id="outlined-basic"
              label="請輸入您的學校/工作"
              value={experience}
              onChange={(e) => {
                setPersonalData({ ...personalData, experience: e.target.value });
                updateData('experience', e.target.value);
                console.log(personalData);
              }}
              variant="outlined"
              style={{ width: '400px', margin: '3% 13% 0 0' }}
              InputProps={{
                style: {
                  fontSize: 14,
                  color: '#595959',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <InputTags
              prompt={'我的軟實力'}
              options={['C', 'C++', 'Python', 'JavaScript'].sort()}
              record={personalData.softPower}
              onUpdate={(e) => {
                setPersonalData({ ...personalData, softPower: e });
                updateData('softPower', e);
                console.log(personalData);
              }}
            />
            <InputTags
              prompt={'我的硬實力'}
              options={[
                'Default1',
                'Default2',
                'Default3',
                'Default4',
                'Default5',
                'Default6',
                'Default7',
                'Default8',
              ].sort()}
              record={personalData.hardPower}
              onUpdate={(e) => {
                setPersonalData({ ...personalData, hardPower: e });
                updateData('hardPower', e);
                console.log(personalData);
              }}
            />
            <TextField
              id="outlined-basic"
              label="我的創業動機"
              value={motivation}
              onChange={(e) => {
                setPersonalData({ ...personalData, motivation: e.target.value });
                updateData('motivation', e.target.value);
                console.log(personalData);
              }}
              variant="outlined"
              style={{ width: '400px', margin: '3% 13% 3% 0' }}
              InputProps={{
                style: {
                  fontSize: 14,
                  color: '#595959',
                },
              }}
              multiline={true}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default observer(Personal);
